import {AccountPerformanceSummary} from "../models/AccountPerformanceSummary";
import {
    HistoricalEquityTrade,
    HistoricalExerciseTrade,
    HistoricalOptionTrade,
    HistoricalTrades
} from "../models/HistoricalTradeData";

export function combineTrades(summary: AccountPerformanceSummary): HistoricalTrades {

    const optionData: HistoricalTrades = summary.historicalOptions.map(HistoricalOptionTrade.of);
    const equityData: HistoricalTrades = summary.historicalEquities.map(HistoricalEquityTrade.of);
    const exPosData: HistoricalTrades = summary.exercisedPositions.map(HistoricalExerciseTrade.of);

    return optionData.concat(equityData).concat(exPosData);
}
